"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icon_1 = require("./Icon");
Object.defineProperty(exports, "Icon", { enumerable: true, get: function () { return Icon_1.Icon; } });
//# sourceMappingURL=index.js.map